import { useEffect, useState } from 'react';
import { useIntl } from 'umi';
import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { getUserWorkingHours } from '@/utils/user';
import { getDays, transformSlotsToUserWorkingHours, transformUserWorkingHoursToSlots } from '@/utils/openHours';
import OpenHours from '@/components/ResourceSettings/OpenHours';


dayjs.extend(customParseFormat);

const UserOpenHours = ({
  user,
  value,
  onChange,
  dataExtractor = getUserWorkingHours,
  toSlotsTransformer = transformUserWorkingHoursToSlots,
  fromSlotsTransformer = transformSlotsToUserWorkingHours,
  supportMultipleEntries = false,
  dataFormatter = (user = {}, transformedData) => ({
    ...user,
    availability: { ...user.availability, working_hours: transformedData }
  })
}) => {
  const intl = useIntl();
  const initialData = getDays(intl);
  const [data, setData] = useState(initialData);

  useEffect(() => {
    setData(initialData);
    if (isEmpty(user) && isEmpty(value)) return;
    const availability = value ? value : dataExtractor(user);
    if (isEmpty(availability)) return;
    const transformedData = toSlotsTransformer(availability, intl);
    setData(transformedData);
  }, [user, dataExtractor, toSlotsTransformer]);

  const handleChange = (newData) => {
    setData(newData);
    const transformedData = fromSlotsTransformer(newData);
    const formattedData = dataFormatter(user, transformedData);
    onChange?.(formattedData, newData);
  };


  return <OpenHours data={data} onChange={handleChange} supportMultipleEntries={supportMultipleEntries} />;
};

export default UserOpenHours;
